import dayjs from "dayjs";
import React, {Component} from "react";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import {removeNullFields} from "../../../../common/mapper";
import PeriodeFilter from "../../common/periodeFilter";
import {defaultTableChange} from "../../../../../modules/custom/customTable";
import moment from "moment";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import { FormatCurrencyWithoutSymbol } from "../../../../../Services/Utils";
import { PaymentStatus } from "../../common/constants";

class TabStatus extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "dataBank.idBank",
            label: "Kode Bank",
            options: {
                sort: false,
            },
        },
        {
            name: "dataBank.bankName",
            label: "Nama Bank",
            options: {
                sort: false,
            },
        },
        {
            name: "dataBank.bankAccountNo",
            label: "No. Rekening",
            options: {
                sort: false,
            },
        },
        {
            name: "dataBank.bankAccountName",
            label: "Nama Rekening",
            options: {
                sort: false,
            },
        },
        {
            name: "paymentRealizationDate",
            label: "Tanggal Realisasi BBM/BBK",
            options: {
                sort: false,
            },
        },
        {
            name: "paymentRealizationDate",
            label: "Tanggal BBM/BBK",
            options: {
                sort: false,
            },
        },
        {
            name: "beginningBalance",
            label: "Saldo Awal (Rp)",
            options: {
                customBodyRender: (value, _) => {

                    return <>{FormatCurrencyWithoutSymbol({number:value})}</>;
                },
                sort: false,
            },
        },
        {
            name: "totalAmountBBM",
            label: "Total BBM Realisasi (Rp)",
            options: {
                customBodyRender: (value, _) => {

                    return <>{FormatCurrencyWithoutSymbol({number:value})}</>;
                },
                sort: false,
            },
        },
        {
            name: "totalAmountBBK",
            label: "Total BBK Realisasi (Rp)",
            options: {
                customBodyRender: (value, _) => {

                    return <>{FormatCurrencyWithoutSymbol({number:value})}</>;
                },
                sort: false,
            },
        },
        {
            name: "finalBalance",
            label: "Saldo Akhir (Rp)",
            options: {
                customBodyRender: (value, _) => {

                    return <>{FormatCurrencyWithoutSymbol({number:value})}</>;
                },
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.inititalSearchData = {
          startPeriodDate: dayjs(new Date()).format("DD-MM-YYYY"),
          endPeriodDate: dayjs(new Date()).format("DD-MM-YYYY"),
        };
        this.initialPagination = {
          totalData: 1,
          page: 1,
          limit: 5,
        };
        this.state = {
            loading: false,
            dataTable: [],
            searchData: this.inititalSearchData,
            submittedFilterData: {},
            skipNextPaginationFetch: false,
            pagination: this.initialPagination,
        };
    }

    componentDidUpdate(prevProps, prevState) { 
        const { pagination, skipNextPaginationFetch } = this.state;
        if (
          (prevState.pagination.page !== pagination.page ||
            prevState.pagination.limit !== pagination.limit) &&
          !this.state.skipNextPaginationFetch
        ) {
          this.fetchData(
            this.state.submittedFilterData,
            pagination.page,
            pagination.limit
          );
        }
        if(skipNextPaginationFetch){
            this.setState({ skipNextPaginationFetch: false });
        }
        if(prevProps.kodeCabang?.value !== this.props.kodeCabang?.value){
            this.handleResetPagination()
            this.fetchData(this.inititalSearchData)
            this.handleRefresh()
        }
    } 

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        this.setState((prevValue) => ({ ...prevValue, submittedFilterData: filter,loading:true }));
        const response = await Api.create("NAGAMAS_TRANSACTION").getPaymentBankStatus({
            paramFilters: removeNullFields({
                kodeCabang: this.props.kodeCabang?.value || "",
                paymentStatus: PaymentStatus.REALISASI,
                ...filter,
                startPeriodDate: filter?.startPeriodDate,
                endPeriodDate: filter?.endPeriodDate,
            }),
            page,
            limit,
        });
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: response.data.data,
                pagination: {
                    ...prevValue.pagination,
                    totalData: response.data.totalData,
                },
            }));
        }
        this.setState({ loading: false });
    };

    handleValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            searchData: {
                ...prevValue.searchData,
                [name]: moment(value).format('DD-MM-YYYY'),
            },
        }));
    };

    handleSubmitFilter = async () => {
        this.handleResetPagination()
        const request = removeNullFields(this.state.searchData);
        this.setState((prevValue) => ({
          ...prevValue,
          loading: true,
          skipNextPaginationFetch: true,
        }));
        await this.fetchData(request);
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    getFilterInput = (data) => ({
        startPeriodDate: data?.startPeriodDate
            ? dayjs(data.startPeriodDate).format("DD-MM-YYYY")
            : null,
        endPeriodDate: data?.endPeriodDate ? dayjs(data.endPeriodDate).format("DD-MM-YYYY") : null,
    });

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: tableState.page + 1,
            },
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                page: 1,
                totalData: 1,
                limit: tableState.rowsPerPage,
            },
        }));
    };
   
    handleRefresh = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            searchData: this.inititalSearchData,
        }));
    };
    
    handleResetPagination = () => {
        this.setState({ pagination: this.initialPagination });
    };

    render() {
        return (
            <div>
                <PeriodeFilter
                    state={this.state}
                    title="Tanggal Realisasi"
                    startDateName="startPeriodDate"
                    endDateName="endPeriodDate"
                    onValueChange={this.handleValueChange}
                    onSubmit={this.handleSubmitFilter}
                />
                <SimpleDataTable
                    toCount={this.state.pagination.totalData}
                    data={this.state.dataTable}
                    columns={this.tableColumns}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={defaultTableChange(this.handleChangePage, this.handleRowsPerPage)}
                />
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </div>
        );
    }
}

export default TabStatus;